import { extractUrlFromLinkJsonLd } from '../url';

/**
 * @deprecated Use extractSmartLinkUrl instead
 */
export var extractLink = function extractLink(jsonLd) {
  var url = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.url;
  if (url) {
    if (typeof url === 'string') {
      return url;
    } else {
      return extractUrlFromLinkJsonLd(url);
    }
  }
};